import { useEffect, useState } from "react";
import { useOperaciones } from "../../hooks/useOperaciones";
import { DatePickerDoble } from "../components/pickers/DatePickerDoble";
import { ContenedorParametros } from "../components/utils/ContenedorParametros";
import { ContenedorTabla } from "../components/utils/ContenedorTabla";
import { useModal } from "../../hooks/useModal";
import { Modal } from "../components/modal/Modal";
import { formatDate } from "../../utils/utils";
import { SearchTable } from "../components/utils/SearchTable";

export const MovimientosRecarga = () => {
    const [ startDate, setStartDate ] = useState(new Date());
    const [ endDate, setEndDate ] = useState(new Date());
    const [ tipoMovimiento, setTipoMovimiento ] = useState(0);
    const [ estado, setEstado ] = useState(0);
    const [ isOpenModalDetalleMovimiento, openModalDetalleMovimiento, closeModalDetalleMovimiento ] = useModal();
    const classNameInput = "text-white h-[30px] rounded px-4 w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const idTablaMovimientos = 'idTablaMovimientos'


    const {
        listarMovimientosRecargas,
        movimientosRecargas,
        detalleMovimientosRecargas,
        listarMovimientosRecargasDetalle,
    } = useOperaciones();

    useEffect(() => {
        listarMovimientosRecargas();
    },[])
    // useEffect(() => {
    //     listarMovimientosRecargasDetalle(startDate, endDate, tipoMovimiento, estado);
    // },[startDate, endDate, tipoMovimiento, estado])
    return(
        <>
            <ContenedorParametros titulo="Movimientos recarga">
                <SearchTable tablaId={idTablaMovimientos}></SearchTable>
            </ContenedorParametros>
            <div className='containerScroll  mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                <table className="table " id={idTablaMovimientos}>
                    <thead>
                        <tr>
                            <th className="text-center">N</th>
                            <th className="text-center">UID</th>
                            <th className="text-center">FECHA ULTIMA ACTUALIZACION</th>
                            <th className='text-right'>IMPORTE</th>
                            <th className="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        movimientosRecargas.length > 0
                        ? movimientosRecargas.map((operacion, i) => {
                            return (
                                <tr key={i + 1}>
                                    <td className='text-center'>{ i + 1 }</td>
                                    <td className="text-center">{operacion.uid || ''}</td>
                                    <td className="text-center">{operacion.fechaUltimaActualizacion || ''}</td>
                                    <td className="text-right">{Number(operacion.saldo || 0).toFixed(2)}</td>
                                    <td className="text-center">
                                        <button
                                            className="px-2 bg-blue-500 hover:bg-blue-700 rounded-md"
                                            onClick={async () => {
                                                await listarMovimientosRecargasDetalle(operacion.uid, 0, 0, '01/01/2020', '31/12/3000')
                                                openModalDetalleMovimiento()
                                            }}
                                        >
                                            <i className="fa-solid fa-list"></i>
                                        </button>
                                    </td>
                                </tr>
                            )
                        })
                        : <tr><td colSpan={9} className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                    }
                    </tbody>
                </table>
            </div>

            <Modal
                title={`Detalle movimientos de recarga`}
                isOpen={isOpenModalDetalleMovimiento}
                closeModal={closeModalDetalleMovimiento}
                textButtons={{ confirm: '', denied:'Cerrar'}}
                validButton={{ confirm: false, denied: true}}
            >
                {/* <div>
                    <DatePickerDoble
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                    <i className="fa-regular fa-credit-card"></i>
                    <select
                        className={classNameInput}
                        onChange={(e) => setTipoMovimiento(Number(e.target.value))}
                    >
                        <option value={0}>--Todos--</option>
                        <option value={1}>Crédito</option>
                        <option value={2}>Débito</option>
                    </select>
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                    <select
                        className={classNameInput + ''}
                        onChange={(e) => setEstado(Number(e.target.value))}
                    >
                        <option value={0}>--Todos--</option>
                    </select>
                </div> */}
                <div className="containerScroll h-[450px] h-max-[450px] overflow-auto px-2 ">
                    <table className="table ">
                        <thead>
                            <tr>
                                <th className="text-center">N</th>
                                <th className="text-center">CODIGO</th>
                                <th className="text-center">UID ORIGEN</th>
                                <th className="text-center">FECHA HORA CREACIÓN </th>
                                <th className="text-center">TIPO MOVIMIENTO</th>
                                <th className="text-center">TIPO MOVIMIENTO DETALLE</th>
                                <th className='text-center'>MONTO</th>
                                <th className="text-center">COMENTARIO</th>
                                <th className="text-center">UID EDICIÓN</th>
                                <th className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            detalleMovimientosRecargas.length > 0
                            ? detalleMovimientosRecargas.map((operacion, i) => {
                                return (
                                    <tr key={i + 1}>
                                        <td className='text-center'>{ i + 1}</td>
                                        <td className="text-center">{operacion.codMovimiento || ''}</td>
                                        <td className="text-center">{operacion.uidOrigen || ''}</td>
                                        <td className="text-center">{formatDate(operacion.fechaHoraCreacion || '', 200)}</td>
                                        <td className="text-center">{operacion.nomMovimientoTipo || ''}</td>
                                        <td className="text-center">{operacion.nomMovimientoDetalleTipo || ''}</td>
                                        <td className="text-center">{Number(operacion.montoMovimiento || 0).toFixed(2)}</td>
                                        <td className="w-[300px] w-max-[300px]" title={operacion.comentario || ''}>
                                            <div className="w-[98%] text-ellipsis whitespace-nowrap overflow-hidden ">{operacion.comentario}</div>
                                        </td>
                                        <td className="">{operacion.uidEdicion || ''}</td>
                                        <td className="text-center"></td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody>
                    </table>
                </div>
            </Modal>
        </>
    )
    
}